import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          {/* <p className="text-sm text-designColor tracking-[4px]">1998 - 2010</p> */}
          <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Master of Information Technology (MIT) "
            subTitle="Virtual University Karachi Campus  "
            result="3.85/4"
            des="focuses on programming, algorithms, preparing students for technology-driven careers. 
            project, and internships."       />
          <ResumeCard
            title="Bachelor of Computer Science (BCS) "
            subTitle="University of Sindh"
            result="3.70/4"
            des="focuses on programming, algorithms, preparing students for technology-driven careers. 
            project, and internships."
          />
          <ResumeCard
            title="Intermediate (FSC)"
            subTitle="Hyderabad Board Completed with first division"
            result="1st/Div"
            des="Education All about Science subjects Meth English Physics Chemestry and education Standard Classification of Education scale."
          />
        </div>
      </div>
      {/* part Two */}

      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Senior Software Engineer"
            subTitle="Zewst  (PRESENTS)  Dec 2023 - Jul 2024"
            result="Islamabad"
            des="Zewst Phone app , Full-Stack E-Commerce website ."
          />
          <ResumeCard
            title="Software Engineer Projects"
            subTitle="Crov-Technology (PRESENTS)  Dec 2022 - Jul 2023"
            result="Islamabad"
            des="React NAtive P2P Service (peer-to-peer) providing Customer and Beautician app good experience with this live applications."
          />
          <ResumeCard
            title="Software Engineer Projects"
            subTitle="Appsware-Technology (PRESENTS)  | Aug 2019 - 2022"
            result="Karachi"
            des="I start my journey mobile apps development Android java and kotlin jetpack composeas well ."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Education;
